import buildingsStore from './BuildingStore/BuildingStore';
import queryParamsStore from './QueryParamsStore/QueryParamsStore';
import pathFinderStore from './PathFinderStore/PathFinderStore';
import nodesStore from './NodesStore/NodesStore';
import defaultDestinationsStore from './DefaultDestinationsStore/DefaultDestinationsStore';
import languagesStore from './LanguagesStore/LanguagesStore';
import uiContentsStore from './UiContentsStore/UiContentsStore';
import linksStore from './LinksStore/LinksStore';
import emailTemplatesStore from './EmailTemplatesStore/EmailTemplatesStore';
import gettingToPageStore from "./pages/GettingTo/GettingToPageStore";
import destCategoriesStore from "./DestCategoriesStore/DestCategoriesStore";

const store = {
     buildingsStore,
     queryParamsStore,
     pathFinderStore,
     nodesStore,
     defaultDestinationsStore,
     languagesStore,
     uiContentsStore,
     linksStore,
     emailTemplatesStore,
     destCategoriesStore,

     gettingToPageStore
};

export default store;
